import { render, staticRenderFns } from "./ClientsDrafts.vue?vue&type=template&id=49fdf144"
import script from "./ClientsDrafts.vue?vue&type=script&lang=js"
export * from "./ClientsDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports